<div class="col gap-24 w100">
  <div class="row gap-16 space-between w100 align-center">
    <h1 i18n>Product Ideas</h1>
    <rr-icon name="close" class="pointer" (click)="close()"></rr-icon>
  </div>
  <div>We analyzed your paper an build concrete suggestions.</div>
  <div class="col gap-16 w100">
    <div
      class="row gap-16 align-center pointer ideawrapper idea"
      [ngClass]="selectedIdea === idea ? 'active' : ''"
      *ngFor="let idea of ideaList"
      (click)="choise(idea)"
    >
      <div class="dot"></div>
      <div class="col gap-8">
        <div class="strong">{{ idea.ideaTitle }}</div>
        <div class="">{{ idea.ideaAbstract }}</div>
      </div>
    </div>
  </div>
</div>

<div class="btnrow row w100 gap-16 align-end justify-end">
  <rr-btn size="Medium" type="Secondary" (click)="close()">Cancel</rr-btn>
  <rr-btn
    size="Medium"
    type="Primary"
    [disabled]="selectedIdea"
    (click)="selectIdea()"
    >Select Idea</rr-btn
  >
</div>
<rr-spinner *ngIf="loading"></rr-spinner>
